import React from 'react'
import { Link } from 'react-router-dom'
import homeRepair from '../img/home-repair.jpg'
import commercial from '../img/commercial.jpg'
import newinstall from '../img/new-install.jpg'

const WorkType = () => {
    return(
        <div className = "card-div">

            <div className="card">

                <img src={homeRepair} alt="home repair" />
                
                <h1 className = "h1-p">Residential Repair</h1>

                <p className="price">$50 hr</p>

                <p className="price" style = {{textAlign: "left"}}>Basic household plumbing.</p>

                <button><Link className="links" style= {{color: "black"}} to= '/services'>More Info</Link></button>

            </div>

            <div className="card">

                <img src={commercial} alt="home repair" />

                <h1 className = "h1-p">Commercial Repair</h1>

                <p className="price">$80 hr</p>

                <p className="price" style = {{textAlign: "left"}}>24 hr. Emergency services. </p>

                <button><Link className="links" style= {{color: "black"}} to= '/services'>More Info</Link></button>

            </div>

            <div className="card">

                <img src={newinstall} alt="home repair" />

                <h1 className = "h1-p">New installations</h1>

                <p className="price">$125 hr</p>

                <p className="price" style = {{textAlign: "left"}}>New plumbing installs</p>

                <button><Link className="links" style= {{color: "black"}} to= '/services'>More Info</Link></button>

            </div>

        </div>        
    )
}

export default WorkType